import React from 'react';
import ProgressLabel from '../ProgressLabel';

const FailedLabel = () => (
    <ProgressLabel text="Failed" color="red" />
);

export default FailedLabel;
